import { departments } from 'Components/constants/appConstants';
import { regex } from '../regex';
import { init } from 'i18next';

export const PhoneNumberCodes = [
    {
        label: 'India(+91)',
        value: '+91',
        validationPattern: '^[6789]\\d{9}$',
        maxLen: '10'
    },
    {
        label: 'Afghanistan (+93)',
        value: '+93',
        validationPattern: '^[0-9]{7,14}$',
        maxLen: '14'
    },
    {
        label: 'Åland Islands (+358)',
        value: '+358',
        validationPattern: '^[0-9]{4,12}$',
        maxLen: '12'
    },
    {
        label: 'Albania (+355)',
        value: '+355',
        validationPattern: '^[0-9]{6,10}$',
        maxLen: '10'
    },
    {
        label: 'Algeria(+213)',
        value: '+213',
        validationPattern: '^[0-9]{9,14}$',
        maxLen: '14'
    },
    {
        label: 'American Samoa (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Andorra (+376)',
        value: '+376',
        validationPattern: '^[0-9]{6}$',
        maxLen: '6'
    },
    {
        label: 'Angola (+244)',
        value: '+244',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Anguilla (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    /*
     * {
     *   "label": "Antarctica ()",
     *   "value": "",
     *  "validationPattern": "",
     *   "maxLen": "",
     * },
     */
    {
        label: 'Antigua and Barbuda (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Argentina (+54)',
        value: '+54',
        validationPattern: '^[0-9]{10,13}$',
        maxLen: '13'
    },
    {
        label: 'Armenia (+374)',
        value: '+374',
        validationPattern: '^[0-9]{6,8}$',
        maxLen: '8'
    },
    {
        label: 'Aruba (+297)',
        value: '+297',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Australia (+61)',
        value: '+61',
        validationPattern: '^[0-9]{9,10}$',
        maxLen: '10'
    },
    {
        label: 'Austria (+43)',
        value: '+43',
        validationPattern: '^[0-9]{4,13}$',
        maxLen: '13'
    },
    {
        label: 'Azerbaijan (+994)',
        value: '+994',
        validationPattern: '^[0-9]{6,12}$',
        maxLen: '12'
    },
    {
        label: 'Bahamas (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Bahrain (+973)',
        value: '+973',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Bangladesh (+880)',
        value: '+880',
        validationPattern: '^[0-9]{10,11}$',
        maxLen: '11'
    },
    {
        label: 'Barbados (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Belarus (+375)',
        value: '+375',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Belgium (+32)',
        value: '+32',
        validationPattern: '^[0-9]{8,9}$',
        maxLen: '9'
    },
    {
        label: 'Belize (+501)',
        value: '+501',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Benin (+229)',
        value: '+229',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Bermuda (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Bhutan (+975)',
        value: '+975',
        validationPattern: '^[0-9]{7,8}$',
        maxLen: '8'
    },
    {
        label: 'Bolivia (+591)',
        value: '+591',
        validationPattern: '^[0-9]{6,12}$',
        maxLen: '12'
    },
    {
        label: 'Bosnia and Herzegovina (+387)',
        value: '+387',
        validationPattern: '^[0-9]{8,9}$',
        maxLen: '9'
    },
    {
        label: 'Botswana (+267)',
        value: '+267',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Bouvet Island ()',
        value: '',
        validationPattern: '',
        maxLen: ''
    },
    {
        label: 'Brazil (+55)',
        value: '+55',
        validationPattern: '^[0-9]{10,11}$',
        maxLen: '11'
    },
    {
        label: 'British Indian Ocean Territory (+246)',
        value: '+246',
        validationPattern: '^[0-9]{3,7}$',
        maxLen: '7'
    },
    {
        label: 'British Virgin Islands (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Brunei (+673)',
        value: '+673',
        validationPattern: '^[0-9]{7,8}$',
        maxLen: '8'
    },
    {
        label: 'Bulgaria (+359)',
        value: '+359',
        validationPattern: '^[0-9]{7,9}$',
        maxLen: '9'
    },
    {
        label: 'Burkina Faso (+226)',
        value: '+226',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Burundi (+257)',
        value: '+257',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Cambodia (+855)',
        value: '+855',
        validationPattern: '^[0-9]{8,9}$',
        maxLen: '9'
    },
    {
        label: 'Cameroon (+237)',
        value: '+237',
        validationPattern: '^[0-9]{8,9}$',
        maxLen: '9'
    },
    {
        label: 'Canada (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Cape Verde (+238)',
        value: '+238',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Cayman Islands (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Central African Republic (+236)',
        value: '+236',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Chad (+235)',
        value: '+235',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Chile (+56)',
        value: '+56',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'China (+86)',
        value: '+86',
        validationPattern: '^[0-9]{11}$',
        maxLen: '11'
    },
    {
        label: 'Christmas Island (+61)',
        value: '+61',
        validationPattern: '^[0-9]{9,10}$',
        maxLen: '10'
    },
    {
        label: 'Cocos (Keeling) Islands (+61)',
        value: '+61',
        validationPattern: '^[0-9]{9,10}$',
        maxLen: '10'
    },
    {
        label: 'Colombia (+57)',
        value: '+57',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Comoros (+269)',
        value: '+269',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Congo (+242)',
        value: '+242',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Democratic Republic of the Congo (+243)',
        value: '+243',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Cook Islands (+682)',
        value: '+682',
        validationPattern: '^[0-9]{5}$',
        maxLen: '5'
    },
    {
        label: 'Costa Rica (+506)',
        value: '+506',
        validationPattern: '^[0-9]{8,9}$',
        maxLen: '9'
    },
    {
        label: 'Croatia (+385)',
        value: '+385',
        validationPattern: '^[0-9]{8,9}$',
        maxLen: '9'
    },
    {
        label: 'Cuba (+53)',
        value: '+53',
        validationPattern: '^[0-9]{7,8}$',
        maxLen: '8'
    },
    {
        label: 'Curaçao (+599)',
        value: '+599',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Cyprus (+357)',
        value: '+357',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Czech Republic (+420)',
        value: '+420',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Denmark (+45)',
        value: '+45',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Djibouti (+253)',
        value: '+253',
        validationPattern: '^[0-9]{6}$',
        maxLen: '6'
    },
    {
        label: 'Dominica (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Dominican Republic (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'East Timor (+670)',
        value: '+670',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Ecuador (+593)',
        value: '+593',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Egypt (+20)',
        value: '+20',
        validationPattern: '^[0-9]{10,11}$',
        maxLen: '11'
    },
    {
        label: 'El Salvador (+503)',
        value: '+503',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Equatorial Guinea (+240)',
        value: '+240',
        validationPattern: '^[0-9]{6}$',
        maxLen: '6'
    },
    {
        label: 'Eritrea (+291)',
        value: '+291',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Estonia (+372)',
        value: '+372',
        validationPattern: '^[0-9]{7,10}$',
        maxLen: '10'
    },
    {
        label: 'Ethiopia (+251)',
        value: '+251',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Falkland Islands (+500)',
        value: '+500',
        validationPattern: '^[0-9]{5}$',
        maxLen: '5'
    },
    {
        label: 'Faroe Islands (+298)',
        value: '+298',
        validationPattern: '^[0-9]{6}$',
        maxLen: '6'
    },
    {
        label: 'Fiji (+679)',
        value: '+679',
        validationPattern: '^[0-9]{7,8}$',
        maxLen: '8'
    },
    {
        label: 'Finland (+358)',
        value: '+358',
        validationPattern: '^[0-9]{4,12}$',
        maxLen: '12'
    },
    {
        label: 'France (+33)',
        value: '+33',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'French Guiana (+594)',
        value: '+594',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'French Polynesia (+689)',
        value: '+689',
        validationPattern: '^[0-9]{6}$',
        maxLen: '6'
    },
    {
        label: 'French Southern Territories ()',
        value: '',
        validationPattern: '',
        maxLen: '10'
    },
    {
        label: 'Gabon (+241)',
        value: '+241',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Gambia (+220)',
        value: '+220',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Georgia (+995)',
        value: '+995',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Germany (+49)',
        value: '+49',
        validationPattern: '^[0-9]{7,12}$',
        maxLen: '12'
    },
    {
        label: 'Ghana (+233)',
        value: '+233',
        validationPattern: '^[0-9]{9,10}$',
        maxLen: '10'
    },
    {
        label: 'Gibraltar (+350)',
        value: '+350',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Greece (+30)',
        value: '+30',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Greenland (+299)',
        value: '+299',
        validationPattern: '^[0-9]{6}$',
        maxLen: '6'
    },
    {
        label: 'Grenada (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Guadeloupe (+590)',
        value: '+590',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Guam (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Guatemala (+502)',
        value: '+502',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Guernsey (+44)',
        value: '+44',
        validationPattern: '^[0-9]{6}$',
        maxLen: '6'
    },
    {
        label: 'Guinea (+224)',
        value: '+224',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Guinea-Bissau (+245)',
        value: '+245',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Guyana (+592)',
        value: '+592',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Haiti (+509)',
        value: '+509',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Heard Island and McDonald Islands ()',
        value: '',
        validationPattern: '',
        maxLen: '10'
    },
    {
        label: 'Honduras (+504)',
        value: '+504',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Hong Kong (+852)',
        value: '+852',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Hungary (+36)',
        value: '+36',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Iceland (+354)',
        value: '+354',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Indonesia (+62)',
        value: '+62',
        validationPattern: '^[0-9]{9,12}$',
        maxLen: '12'
    },
    {
        label: 'Iran (+98)',
        value: '+98',
        validationPattern: '^[0-9]{10,11}$',
        maxLen: '11'
    },
    {
        label: 'Iraq (+964)',
        value: '+964',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Ireland (+353)',
        value: '+353',
        validationPattern: '^[0-9]{7,9}$',
        maxLen: '9'
    },
    {
        label: 'Isle of Man (+44)',
        value: '+44',
        validationPattern: '^[0-9]{6}$',
        maxLen: '6'
    },
    {
        label: 'Israel (+972)',
        value: '+972',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Italy (+39)',
        value: '+39',
        validationPattern: '^[0-9]{6,11}$',
        maxLen: '11'
    },
    {
        label: 'Jamaica (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Japan (+81)',
        value: '+81',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Jersey (+44)',
        value: '+44',
        validationPattern: '^[0-9]{6}$',
        maxLen: '6'
    },
    {
        label: 'Jordan (+962)',
        value: '+962',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Kazakhstan (+7)',
        value: '+7',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Kenya (+254)',
        value: '+254',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Kiribati (+686)',
        value: '+686',
        validationPattern: '^[0-9]{5}$',
        maxLen: '5'
    },
    {
        label: 'Kuwait (+965)',
        value: '+965',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Kyrgyzstan (+996)',
        value: '+996',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Laos (+856)',
        value: '+856',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Latvia (+371)',
        value: '+371',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Lebanon (+961)',
        value: '+961',
        validationPattern: '^[0-9]{7,8}$',
        maxLen: '8'
    },
    {
        label: 'Lesotho (+266)',
        value: '+266',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Liberia (+231)',
        value: '+231',
        validationPattern: '^[0-9]{7,8}$',
        maxLen: '8'
    },
    {
        label: 'Libya (+218)',
        value: '+218',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Liechtenstein (+423)',
        value: '+423',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Lithuania (+370)',
        value: '+370',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Luxembourg (+352)',
        value: '+352',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Macao (+853)',
        value: '+853',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'North Macedonia (+389)',
        value: '+389',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Madagascar (+261)',
        value: '+261',
        validationPattern: '^[0-9]{9,10}$',
        maxLen: '10'
    },
    {
        label: 'Malawi (+265)',
        value: '+265',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Malaysia (+60)',
        value: '+60',
        validationPattern: '^[0-9]{8,9}$',
        maxLen: '9'
    },
    {
        label: 'Maldives (+960)',
        value: '+960',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Mali (+223)',
        value: '+223',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Malta (+356)',
        value: '+356',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Marshall Islands (+692)',
        value: '+692',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Martinique (+596)',
        value: '+596',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Mauritania (+222)',
        value: '+222',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Mauritius (+230)',
        value: '+230',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Mayotte (+262)',
        value: '+262',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Mexico (+52)',
        value: '+52',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Micronesia (+691)',
        value: '+691',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Moldova (+373)',
        value: '+373',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Monaco (+377)',
        value: '+377',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Mongolia (+976)',
        value: '+976',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Montenegro (+382)',
        value: '+382',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Montserrat (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Morocco (+212)',
        value: '+212',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Mozambique (+258)',
        value: '+258',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Myanmar (+95)',
        value: '+95',
        validationPattern: '^[0-9]{7,11}$',
        maxLen: '11'
    },
    {
        label: 'Namibia (+264)',
        value: '+264',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Nauru (+674)',
        value: '+674',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Nepal (+977)',
        value: '+977',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Netherlands (+31)',
        value: '+31',
        validationPattern: '^[0-9]{9,10}$',
        maxLen: '10'
    },
    {
        label: 'New Caledonia (+687)',
        value: '+687',
        validationPattern: '^[0-9]{6}$',
        maxLen: '6'
    },
    {
        label: 'New Zealand (+64)',
        value: '+64',
        validationPattern: '^[0-9]{8,11}$',
        maxLen: '11'
    },
    {
        label: 'Nicaragua (+505)',
        value: '+505',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Niger (+227)',
        value: '+227',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Nigeria (+234)',
        value: '+234',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Niue (+683)',
        value: '+683',
        validationPattern: '^[0-9]{4}$',
        maxLen: '4'
    },
    {
        label: 'Norfolk Island (+672)',
        value: '+672',
        validationPattern: '^[0-9]{5}$',
        maxLen: '5'
    },
    {
        label: 'North Korea (+850)',
        value: '+850',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Northern Mariana Islands (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Norway (+47)',
        value: '+47',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Oman (+968)',
        value: '+968',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Pakistan (+92)',
        value: '+92',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Palau (+680)',
        value: '+680',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Palestine (+970)',
        value: '+970',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Panama (+507)',
        value: '+507',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Papua New Guinea (+675)',
        value: '+675',
        validationPattern: '^[0-9]{7,8}$',
        maxLen: '8'
    },
    {
        label: 'Paraguay (+595)',
        value: '+595',
        validationPattern: '^[0-9]{7,9}$',
        maxLen: '9'
    },
    {
        label: 'Peru (+51)',
        value: '+51',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Philippines (+63)',
        value: '+63',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Pitcairn (+870)',
        value: '+870',
        validationPattern: '^[0-9]{4}$',
        maxLen: '4'
    },
    {
        label: 'Poland (+48)',
        value: '+48',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Portugal (+351)',
        value: '+351',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Puerto Rico (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Qatar (+974)',
        value: '+974',
        validationPattern: '^[0-9]{7,8}$',
        maxLen: '8'
    },
    {
        label: 'Republic of the Congo (+242)',
        value: '+242',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Réunion (+262)',
        value: '+262',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Romania (+40)',
        value: '+40',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Russia (+7)',
        value: '+7',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Rwanda (+250)',
        value: '+250',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Saint Barthélemy (+590)',
        value: '+590',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Saint Helena (+290)',
        value: '+290',
        validationPattern: '^[0-9]{4}$',
        maxLen: '4'
    },
    {
        label: 'Saint Kitts and Nevis (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Saint Lucia (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Saint Martin (+590)',
        value: '+590',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Saint Pierre and Miquelon (+508)',
        value: '+508',
        validationPattern: '^[0-9]{6}$',
        maxLen: '6'
    },
    {
        label: 'Saint Vincent and the Grenadines (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Samoa (+685)',
        value: '+685',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'San Marino (+378)',
        value: '+378',
        validationPattern: '^[0-9]{6}$',
        maxLen: '6'
    },
    {
        label: 'São Tomé and Príncipe (+239)',
        value: '+239',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Saudi Arabia (+966)',
        value: '+966',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Senegal (+221)',
        value: '+221',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Serbia (+381)',
        value: '+381',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Seychelles (+248)',
        value: '+248',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Sierra Leone (+232)',
        value: '+232',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Singapore (+65)',
        value: '+65',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Sint Maarten (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Saint Pierre and Miquelon (+508)',
        value: '+508',
        validationPattern: '^[0-9]{6}$',
        maxLen: '6'
    },
    {
        label: 'Saint Vincent and the Grenadines (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Samoa (+685)',
        value: '+685',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'San Marino (+378)',
        value: '+378',
        validationPattern: '^[0-9]{6}$',
        maxLen: '6'
    },
    {
        label: 'São Tomé and Príncipe (+239)',
        value: '+239',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Saudi Arabia (+966)',
        value: '+966',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Senegal (+221)',
        value: '+221',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Serbia (+381)',
        value: '+381',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Seychelles (+248)',
        value: '+248',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Sierra Leone (+232)',
        value: '+232',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Singapore (+65)',
        value: '+65',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Sint Maarten (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Slovakia (+421)',
        value: '+421',
        validationPattern: '^[0-9]{9}$',
        maxLen: '8'
    },
    {
        label: 'Slovenia (+386)',
        value: '+386',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Solomon Islands (+677)',
        value: '+677',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Somalia (+252)',
        value: '+252',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'South Africa (+27)',
        value: '+27',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'South Georgia and the South Sandwich Islands (+500)',
        value: '+500',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'South Korea (+82)',
        value: '+82',
        validationPattern: '^[0-9]{9,11}$',
        maxLen: '11'
    },
    {
        label: 'South Sudan (+211)',
        value: '+211',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Spain (+34)',
        value: '+34',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Sri Lanka (+94)',
        value: '+94',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Sudan (+249)',
        value: '+249',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Suriname',
        value: '+597',
        validationPattern: '^[0-9]{6}$',
        maxLen: '6'
    },
    {
        label: 'Svalbard and Jan Mayen (+47)',
        value: '+47',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Eswatini (+268)',
        value: '+268',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Sweden (+46)',
        value: '+46',
        validationPattern: '^[0-9]{9,10}$',
        maxLen: '10'
    },
    {
        label: 'Switzerland (+41)',
        value: '+41',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Syria (+963)',
        value: '+963',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Taiwan (+886)',
        value: '+886',
        validationPattern: '^[0-9]{9,10}$',
        maxLen: '10'
    },
    {
        label: 'Tajikistan (+992)',
        value: '+992',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Tanzania (+255)',
        value: '+255',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Thailand (+66)',
        value: '+66',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Timor-Leste (+670)',
        value: '+670',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Togo (+228)',
        value: '+228',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Tokelau (+690)',
        value: '+690',
        validationPattern: '^[0-9]{4}$',
        maxLen: '4'
    },
    {
        label: 'Tonga (+676)',
        value: '+676',
        validationPattern: '^[0-9]{5}$',
        maxLen: '5'
    },
    {
        label: 'Trinidad and Tobago (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Tunisia (+216)',
        value: '+216',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Turkey (+90)',
        value: '+90',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Turkmenistan (+993)',
        value: '+993',
        validationPattern: '^[0-9]{8}$',
        maxLen: '8'
    },
    {
        label: 'Turks and Caicos Islands (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Tuvalu (+688)',
        value: '+688',
        validationPattern: '^[0-9]{5}$',
        maxLen: '5'
    },
    {
        label: 'Uganda (+256)',
        value: '+256',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Ukraine (+380)',
        value: '+380',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'United Arab Emirates (+971)',
        value: '+971',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'United Kingdom (+44)',
        value: '+44',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'United States (+1)',
        value: '+1',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Uruguay (+598)',
        value: '+598',
        validationPattern: '^[0-9]{7,9}$',
        maxLen: '9'
    },
    {
        label: 'Uzbekistan (+998)',
        value: '+998',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Vanuatu (+678)',
        value: '+678',
        validationPattern: '^[0-9]{7}$',
        maxLen: '7'
    },
    {
        label: 'Vatican City (+39)',
        value: '+39',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Venezuela (+58)',
        value: '+58',
        validationPattern: '^[0-9]{10}$',
        maxLen: '10'
    },
    {
        label: 'Vietnam (+84)',
        value: '+84',
        validationPattern: '^[0-9]{9,10}$',
        maxLen: '10'
    },
    {
        label: 'Wallis and Futuna (+681)',
        value: '+681',
        validationPattern: '^[0-9]{6}$',
        maxLen: '6'
    },
    {
        label: 'Yemen (+967)',
        value: '+967',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Zambia (+260)',
        value: '+260',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    },
    {
        label: 'Zimbabwe (+263)',
        value: '+263',
        validationPattern: '^[0-9]{9}$',
        maxLen: '9'
    }
];

export const SIGNUP_FORM_SCHEMA = [
    {
        label: 'First Name',
        value: 'firstName',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        regex: regex.alphabets,
        alphabets: true,
        lg1: 6,
        maxLen: 20,
        minLen: 3
    },
    {
        label: 'Last Name',
        value: 'lastName',
        inputType: 'input',
        type: 'text',
        isVisible: true,
        mandatory: true,
        regex: regex.alphabets,
        alphabets: true,
        lg1: 6,
        maxLen: 20,
        minLen: 3
    },
    {
        label: 'Employee ID',
        value: 'empId',
        inputType: 'input',
        maxLen: 10,
        type: 'text',
        isVisible: true,
        mandatory: true,
        regex: regex.numbers,
        numbers: true,
        lg1: 12,
        minLen: 8
    },
    {
        label: 'Email',
        value: 'email',
        inputType: 'input',
        type: 'text',
        isVisible: true,
        mandatory: true,
        regex: regex.email,
        alphanumericspecial: true,
        lg1: 6
    },
    {
        label: 'Contact Number',
        value: 'phoneNumber',
        type: 'tel',
        inputType: 'inputgroup',
        mandatory: true,
        isVisible: true,
        inputgroupKey: 'phoneExtension',
        size: 6,
        notAllowZeros: true,
        phoneNumber: true,
        regex: regex.numbers,
        numbers: true,
        initialValue: {
            for: 'phoneExtension',
            label: 'India(+91)',
            value: '+91',
            validationPattern: '^[6789]\\d{9}$',
            maxLen: '10'
        }
    },
    {
        label: 'Department',
        value: 'department',
        placeholder: 'Department',
        inputType: 'dropdown',
        type: 'object',
        mandatory: true,
        isVisible: true,
        // maxLen: 20,
        options: [],
        lg1: 12
    },
    {
        label: 'Other Department',
        value: 'otherDepartment',
        inputType: 'input',
        type: 'text',
        mandatory: false,
        isVisible: false,
        regex: regex.alphabets,
        alphabets: true,
        lg1: 12,
        maxLen: 20
    },
    // {
    //     label: 'Areas',
    //     value: 'areas',
    //     placeholder: 'Areas',
    //     inputType: 'dropdown',
    //     type: 'array',
    //     mandatory: true,
    //     isVisible: true,
    //     isMulti: true,
    //     options: [],
    //     lg1: 12
    // },
    // {
    //     label: 'Mines',
    //     value: 'mines',
    //     placeholder: 'Mining',
    //     inputType: 'dropdown',
    //     type: 'array',
    //     mandatory: true,
    //     isVisible: true,
    //     isMulti: true,
    //     options: [],
    //     lg1: 12
    // },
    {
        label: 'Address',
        value: 'address',
        inputType: 'input',
        type: 'textarea',
        mandatory: true,
        isVisible: true,
        regex: regex.alphanumericSpecialChars,
        alphanumericspecial: true,
        lg1: 12
    },
    {
        label: 'Upload Profile Image',
        value: 'profile',
        type: 'array',
        inputType: 'upload',
        mandatory: false,
        isVisible: true,
        isMultipleFiles: false,
        accept: { 'image/': ['.jpeg', '.png', '.jpg', '.svg'] },
        // fileTypeMsg: "Only JPEG, JPG, PNG files are accepted",
        fileSize: 52428800,
        noOfFiles: 1,
        size: 12,
        lg1: 12,
        xl: 12,
        height: 50
    }
];

export const CHOOSE_ROLE_FORM_SCHEMA = [
    {
        label: 'Role',
        value: 'role',
        placeholder: 'Role',
        inputType: 'dropdown',
        type: 'object',
        mandatory: false,
        options: [],
        lg1: 12
    }
];

export const EMPLOYEE_ID_FORM_SCHEMA = [
    {
        label: 'Employee ID',
        value: 'employeID',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        regex: regex.numbers,
        numbers: true,
        lg1: 12,
        minLen: 8,
        maxLen: 10
    }
];
export const fileSizeOptions = [
    { label: 'BYTES', value: 'BYTES' },
    { label: 'KB', value: 'KB' },
    { label: 'MB', value: 'MB' },
    { label: 'GB', value: 'GB' }
];

export const ADD_SOURCE_FORM_SCHEMA = [
    {
        label: 'Data Type',
        value: 'dataType',
        placeholder: 'Data Type',
        inputType: 'dropdown',
        type: 'object',
        options: [
            { label: 'Raster', value: 'raster' },
            { label: 'Vector', value: 'vector' }
        ],
        mandatory: true,
        isVisible: true,
        lg1: 6
    },
    {
        label: 'Layer Type',
        value: 'layerType',
        placeholder: 'Layer Type',
        inputType: 'dropdown',
        type: 'object',
        options: [
            { label: 'DSM', value: 'DSM' },
            { label: 'DTM', value: 'DTM' },
            { label: 'Ortho', value: 'Ortho' }
        ],
        mandatory: true,
        isVisible: false,
        lg1: 6
    },
    {
        label: 'Source Name',
        value: 'sourceName',
        placeholder: 'Source Name',
        inputType: 'input',
        type: 'text',
        regex: regex.alphanumericSpecialChars,
        alphanumericSpecialChars: true,
        mandatory: true,
        isVisible: true,
        lg1: 6
    },
    {
        label: 'Area(In Hectares)',
        value: 'area',
        placeholder: 'Area',
        inputType: 'input',
        type: 'decimal',
        notAllowZeros: true,
        mandatory: false,
        isVisible: true,
        maxLen: 10,
        lg1: 6
    },
    {
        label: 'Source Link',
        value: 'sourceURL',
        placeholder: 'Source Link',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        lg1: 6
    },
    {
        label: 'Priority',
        value: 'priority',
        placeholder: 'Priority',
        inputType: 'input',
        type: 'text',
        regex: regex.numbers,
        numbers: true,
        mandatory: true,
        isVisible: true,
        lg1: 6
    },
    {
        label: 'Source Display Name',
        value: 'sourceDisplayName',
        placeholder: 'Source Display Name',
        inputType: 'input',
        type: 'text',
        regex: regex.alphanumericSpecialChars,
        alphanumericSpecialChars: true,
        mandatory: true,
        isVisible: true,
        maxLen: 200,
        lg1: 6
        // lg: 6
    },
    {
        label: 'Department',
        value: 'departmentId',
        placeholder: 'Select Department',
        inputType: 'dropdown',
        type: 'object',
        options: [],
        mandatory: true,
        isVisible: true,
        lg1: 6
    },
    {
        label: 'Sub Category',
        value: 'subcategoryid',
        placeholder: 'Select Sub Category',
        inputType: 'dropdown',
        type: 'object',
        options: [],
        mandatory: false,
        isVisible: true,
        lg1: 6,
        disabled: true
    },
    {
        label1: 'Visibility',
        value: 'visibility',
        inputType: 'checkbox',
        type: 'checkbox',
        checked: false,
        mandatory: false,
        isVisible: true,
        lg1: 2
    },
    {
        label1: 'Open Access',
        value: 'openAccess',
        inputType: 'checkbox',
        type: 'checkbox',
        checked: false,
        mandatory: false,
        isVisible: true,
        lg1: 3
    },
    {
        label1: 'Source data visibility',
        value: 'identifier',
        inputType: 'checkbox',
        type: 'checkbox',
        checked: false,
        mandatory: false,
        isVisible: true,
        lg1: 7
    }
];

export const ADD_SOURCE3D_FORM_SCHEMA = [
    {
        label: 'File Name',
        value: 'fileName',
        inputType: 'input',
        type: 'text',
        // regex: regex.alphanumericSpecialChars,
        // alphanumericSpecialChars: true,
        mandatory: true,
        isVisible: true,
        lg1: 12,
        maxLen: 20
    },
    {
        label: 'File Link',
        value: 'fileURL',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        lg1: 12
    },
    {
        label1: 'Open Access',
        value: 'openAccess',
        inputType: 'checkbox',
        type: 'checkbox',
        checked: false,
        mandatory: false,
        isVisible: true,
        lg1: 12
    }
];

export const MINE_SCHEMA = [
    {
        label: 'Select Mine',
        value: 'mine',
        placeholder: ' a Mine',
        type: 'object',
        inputType: 'dropdown',
        mandatory: false,
        options: [],
        lg: 12
    }
];

export const ADD_REPORT_FORM_SCHEMA = [
    {
        label: 'Deliverable Name',
        value: 'deliverableName',
        inputType: 'input',
        regex: regex.alphaNumeric,
        alphaNumeric: true,
        type: 'text',
        mandatory: true,
        isVisible: true,
        maxLen: 20,
        disabled: false
    },
    {
        label: 'Department',
        value: 'departmentid',
        placeholder: 'a Department',
        type: 'object',
        inputType: 'dropdown',
        mandatory: true,
        isVisible: true,
        options: [],
        lg: 12
    },
    {
        label: 'Sub - Category',
        value: 'subcategoryid',
        placeholder: 'a Sub-category',
        type: 'object',
        inputType: 'dropdown',
        mandatory: false,
        isVisible: true,
        options: [],
        lg: 12,
        disabled: true
    },
    {
        label: 'Upload Report',
        value: 'fileName',
        type: 'array',
        inputType: 'upload',
        mandatory: true,
        isVisible: true,
        isMultipleFiles: false,
        accept: {
            'application/pdf': ['.pdf'],
            'application/x-pdf': ['.pdf'],
            'application/vnd.ms-excel': ['.xls'],
            'application/x-excel': ['.xls'],
            'application/x-msexcel': ['.xls'],
            'application/excel': ['.xls'],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
            'application/zip': ['.xlsx'],
            'application/x-zip-compressed': ['.xlsx'],
            'application/msword': ['.doc'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
        },
        // fileTypeMsg: "Only JPEG, JPG, PNG files are accepted",
        fileSize: 52428800,
        noOfFiles: 1,
        size: 12,
        lg: 12,
        xl: 12,
        isDisabled: true
    }
];

export const ADD_DOWNLOAD_FORM_SCHEMA = [
    {
        label: 'Deliverable Name',
        value: 'deliverableName',
        placeholder: 'Deliverable Name',
        regex: regex.alphaNumeric,
        alphaNumeric: true,
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        maxLen: 20,
        disabled: false
    },
    {
        label: 'Department',
        value: 'departmentid',
        placeholder: 'a Department',
        type: 'object',
        inputType: 'dropdown',
        mandatory: true,
        isVisible: true,
        options: [],
        lg: 12
    },
    {
        label: 'Sub - Category',
        value: 'subcategoryid',
        placeholder: 'a Sub-category',
        type: 'object',
        inputType: 'dropdown',
        mandatory: false,
        isVisible: true,
        options: [],
        lg: 12,
        disabled: true
    },
    {
        label: 'Upload File',
        value: 'fileName',
        type: 'array',
        inputType: 'upload',
        mandatory: true,
        isVisible: true,
        isMultipleFiles: false,
        accept: {
            'application/pdf': ['.pdf'],
            'application/x-pdf': ['.pdf'],
            'application/vnd.ms-excel': ['.xls'],
            'application/x-excel': ['.xls'],
            'application/x-msexcel': ['.xls'],
            'application/excel': ['.xls'],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
            'application/zip': ['.xlsx'],
            'application/x-zip-compressed': ['.xlsx'],
            'application/msword': ['.doc'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
        },
        fileSize: 52428800,
        noOfFiles: 1,
        size: 12,
        lg: 12,
        xl: 12,
        isDisabled: true
    }
];

export const ADD_EMPLOYEEE_ID_FROM_SCHEMA = [
    {
        label: 'Employee ID',
        value: 'employeeID',
        placeholder: 'Employee ID',
        inputType: 'input',
        type: 'text',
        regex: regex.numbers,
        numbers: true,
        mandatory: true,
        isVisible: true,
        maxLen: 10,
        minLen: 8
    }
];

export const ADD_UPLOAD_FORM_SCHEMA = [
    {
        label: 'Upload File',
        value: 'uploadEmployeeIdFile',
        type: 'array',
        inputType: 'upload',
        mandatory: true,
        isMultipleFiles: false,
        accept: {
            'application/vnd.ms-excel': ['.xls'],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
        },
        fileSize: 52428800,
        noOfFiles: 1,
        size: 12,
        md: 12,
        xl: 12,
        isUploadButton: true,
        isVisible: true
    }
];

export const ADD_REGIONS = [
    {
        label: 'Region Name',
        value: 'regionName',
        placeholder: 'Enter Region Name',
        inputType: 'input',
        type: 'text',
        regex: regex.alphaNumeric,
        alphaNumeric: true,
        mandatory: true,
        isVisible: true,
        maxLen: 50,
        lg1: 12
    }
];

export const ADD_AREAS = [
    {
        label: 'Area Name',
        value: 'areaName',
        placeholder: 'Area Name',
        inputType: 'input',
        type: 'text',
        regex: regex.alphaNumeric,
        alphaNumeric: true,
        mandatory: true,
        isVisible: true,
        maxLen: 20,
        lg1: 6
    },
    {
        label: 'Area Description',
        value: 'description',
        placeholder: 'Area Description',
        inputType: 'input',
        type: 'text',
        regex: regex.alphanumericSpecialChars,
        alphanumericSpecialChars: true,
        mandatory: false,
        isVisible: true,
        maxLen: 100,
        lg1: 6
    },

    {
        label: 'Pincode',
        value: 'pinCode',
        placeholder: 'Pincode',
        inputType: 'input',
        type: 'text',
        regex: regex.numbers,
        numbers: true,
        mandatory: true,
        isVisible: true,
        maxLen: 6,
        lg1: 6
    },
    {
        label: 'Country',
        value: 'country',
        placeholder: 'Country',
        inputType: 'dropdown',
        type: 'object',
        options: [
            { label: 'India', value: 'India' }
            // { label: 'United States', value: 'United States' },
            // { label: 'Canada', value: 'Canada' },
            // { label: 'Australia', value: 'Australia' },
            // { label: 'Germany', value: 'Germany' }
        ],
        mandatory: true,
        isVisible: true,
        lg1: 6
    },
    {
        label: 'State',
        value: 'state',
        placeholder: 'State',
        inputType: 'dropdown',
        type: 'object',
        options: [],
        mandatory: true,
        isVisible: true,
        lg1: 6
    },
    {
        label: 'Address',
        value: 'address',
        placeholder: 'Address',
        inputType: 'input',
        type: 'text',
        regex: regex.alphanumericSpecialChars,
        alphanumericSpecialChars: true,
        mandatory: true,
        isVisible: true,
        maxLen: 100,
        lg1: 6
    }
];

export const ADD_MINES = [
    {
        label: 'Mine Name',
        value: 'mineName',
        placeholder: 'Mine Name ',
        inputType: 'input',
        type: 'text',
        regex: regex.alphaNumeric,
        alphaNumeric: true,
        mandatory: true,
        isVisible: true,
        maxLen: 20,
        lg1: 6
    },
    {
        label: 'Area/Distance',
        value: 'distance',
        placeholder: 'Enter',
        inputType: 'inputWithUnit',
        type: 'number',
        unit: 'In Hec',
        mandatory: true,
        isVisible: true,
        lg1: 6
    },
    {
        label: 'Min Lat, Long',
        value: 'minLatLong',
        placeholder: 'Latitude',
        inputType: 'input',
        type: 'text',
        regex: regex.alphanumericSpecialChars,
        alphanumericSpecialChars: true,
        mandatory: true,
        isVisible: true,
        // maxLen: 15,
        lg1: 6
    },
    {
        label: 'Max Lat, Long',
        value: 'maxLatLong',
        placeholder: 'Longitude',
        inputType: 'input',
        type: 'text',
        regex: regex.alphanumericSpecialChars,
        alphanumericSpecialChars: true,
        mandatory: true,
        isVisible: true,
        // maxLen: 15,
        lg1: 6
    },
    {
        label: 'Date of Mining Survey',
        value: 'miningDate',
        placeholder: 'Date of Mining',
        inputType: 'dateRange',
        mandatory: false,
        isVisible: true,
        pickerMode: 'single',
        // maxLen: 100,
        type: 'emptyDate',
        lg1: 6
    },
    {
        label: 'Frequency',
        value: 'frequency',
        placeholder: 'Frequency',
        inputType: 'dropdown',
        type: 'object',
        options: [
            { label: 'One Time', value: 'One Time' },
            { label: 'Weekly', value: 'Weekly' },
            { label: 'Bi – Weekly', value: 'Bi – Weekly' },
            { label: 'Monthly', value: 'Monthly' },
            { label: 'Custom', value: 'Custom' }
        ],
        mandatory: false,
        dynamic: true,
        isVisible: true,
        lg1: 6
    },
    {
        label: 'Custom Frequency',
        value: 'customfrequency',
        placeholder: 'Custom Frequency',
        inputType: 'input',
        type: 'text',
        regex: regex.alphanumericSpecialChars,
        // alphanumericSpecialChars: true,
        mandatory: false,
        isVisible: false,
        maxLen: 10,
        lg1: 6
    },
    {
        label: '% Completion',
        value: 'compeltionPercent',
        placeholder: '% Completion',
        inputType: 'input',
        type: 'number',
        // regex: regex.alphanumericSpecialChars,
        // alphanumericSpecialChars: true,
        mandatory: true,
        isVisible: true,
        maxLen: 20,
        lg1: 6
    }
    // {
    //     label: 'Zoom',
    //     value: 'zoomLevel',
    //     placeholder: 'Zoom',
    //     inputType: 'input',
    //     type: 'number',
    //     // regex: regex.alphanumericSpecialChars,
    //     // alphanumericSpecialChars: true,
    //     mandatory: true,
    //     isVisible: true,
    //     maxLen: 20,
    //     lg1: 6
    // },
    // {
    //     label: 'Minimum Zoom',
    //     value: 'minZoomLevel',
    //     placeholder: 'Minimum Zoom',
    //     inputType: 'input',
    //     type: 'number',
    //     // regex: regex.alphanumericSpecialChars,
    //     // alphanumericSpecialChars: true,
    //     mandatory: true,
    //     isVisible: true,
    //     maxLen: 20,
    //     lg1: 6
    // },
    // {
    //     label: 'Maximum Zoom',
    //     value: 'maxZoomLevel',
    //     placeholder: 'Maximum Zoom',
    //     inputType: 'input',
    //     type: 'number',
    //     // regex: regex.alphanumericSpecialChars,
    //     // alphanumericSpecialChars: true,
    //     mandatory: true,
    //     isVisible: true,
    //     maxLen: 20,
    //     lg1: 6
    // }
];

export const ADMIN_ADD_USER_FORM_SCHEMA = [
    {
        label: 'First Name',
        value: 'firstName',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        regex: regex.alphabets,
        alphabets: true,
        lg1: 6,
        maxLen: 20,
        minLen: 3
    },
    {
        label: 'Last Name',
        value: 'lastName',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,

        regex: regex.alphabets,
        alphabets: true,
        lg1: 6,
        maxLen: 10,
        minLen: 3
    },
    {
        label: 'Employee ID',
        value: 'empId',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        regex: regex.numbers,
        maxLen: 10,
        numbers: true,
        lg1: 6,
        minLen: 8
    },
    {
        label: 'Email',
        value: 'email',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,

        regex: regex.email,
        alphanumericspecial: true,
        lg1: 6
    },
    {
        label: 'Department',
        value: 'department',
        placeholder: 'Department',
        inputType: 'dropdown',
        type: 'object',
        mandatory: true,
        isVisible: true,
        isClearable: true,
        options: departments,
        lg1: 6
    },
    // {
    //     label: 'Other Department',
    //     value: 'otherDepartment',
    //     inputType: 'input',
    //     type: 'text',
    //     mandatory: false,
    //     isVisible: false,
    //     regex: regex.alphabets,
    //     alphabets: true,
    //     lg1: 6,
    //     maxLen: 20
    // },

    {
        label: 'Contact Number',
        value: 'phoneNumber',
        type: 'tel',
        inputType: 'inputgroup',
        mandatory: true,
        isVisible: true,
        inputgroupKey: 'phoneExtension',
        size: 6,
        notAllowZeros: true,
        phoneNumber: true,
        regex: regex.numbers,
        numbers: true,
        initialValue: {
            for: 'phoneExtension',
            label: 'India(+91)',
            value: '+91',
            validationPattern: '^[6789]\\d{9}$',
            maxLen: '10'
        }
    },
    // {
    //     label: 'Areas',
    //     value: 'areas',
    //     placeholder: 'Areas',
    //     inputType: 'dropdown',
    //     type: 'object',
    //     mandatory: true,
    //     options: [
    //         {
    //             value: 'area1',
    //             label: 'area1'
    //         },
    //         {
    //             value: 'area2',
    //             label: 'area2'
    //         }
    //     ],
    //     lg1: 12
    // },
    // {
    //     label: 'Mining',
    //     value: 'mining',
    //     placeholder: 'Mining',
    //     inputType: 'dropdown',
    //     type: 'array',
    //     mandatory: true,
    //     isMulti: true,
    //     options: [
    //         {
    //             value: 'mining1',
    //             label: 'mining1'
    //         },
    //         {
    //             value: 'mining2',
    //             label: 'mining2'
    //         }
    //     ],
    //     lg1: 12
    // },
    {
        label: 'Address',
        value: 'address',
        inputType: 'input',
        type: 'textarea',
        mandatory: true,
        isVisible: true,
        regex: regex.alphanumericSpecialChars,
        alphanumericspecial: true,
        lg1: 6
    },
    {
        label: 'Upload Profile Image',
        value: 'profile',
        type: 'array',
        inputType: 'upload',
        mandatory: false,
        isVisible: true,
        isMultipleFiles: false,
        accept: { 'image/': ['.jpeg', '.png', '.jpg', '.svg'] },
        // fileTypeMsg: "Only JPEG, JPG, PNG files are accepted",
        fileSize: 52428800,
        noOfFiles: 1,
        size: 12,
        lg1: 6,
        xl: 12,
        height: 50
    }
];

export const ADMIN_ADD_ROLE_FORMSCHEMA = [
    {
        label: 'Role',
        value: 'role',
        placeholder: 'Role',
        inputType: 'dropdown',
        type: 'object',
        mandatory: true,
        isVisible: true,
        options: [
            {
                id: 'R1023',
                value: 'admin',
                label: 'Admin'
            },
            {
                id: 'R2048',
                value: 'corporate nodal officer',
                label: 'Corporate Nodal Officer'
            },
            {
                id: 'R3071',
                value: 'nodal officer',
                label: 'Nodal Officer'
            },
            {
                id: 'R4096',
                value: 'user',
                label: 'User'
            }
        ],
        lg1: 12
    },
    {
        label: 'Regions',
        value: 'regions',
        placeholder: 'Regions',
        inputType: 'dropdown',
        type: 'array',
        mandatory: true,
        isVisible: false,
        isMulti: true,
        options: [],
        lg1: 12
    },
    {
        label: 'Areas',
        value: 'areas',
        placeholder: 'Areas',
        inputType: 'dropdown',
        type: 'array',
        mandatory: true,
        isVisible: false,
        isMulti: true,
        options: [],
        lg1: 12
    },
    {
        label: 'Mines',
        value: 'mines',
        placeholder: 'Mines',
        inputType: 'dropdown',
        type: 'array',
        mandatory: false,
        isVisible: false,
        isMulti: true,
        options: [],
        lg1: 12
    },
    {
        value: 'heading',
        inputType: 'heading',
        isVisible: true
    }
];

export const NEW_USER_REQUESTS_FORM_SCHEMA = [
    {
        label: 'Areas',
        value: 'areas',
        placeholder: 'Areas',
        inputType: 'dropdown',
        type: 'array',
        options: [],
        mandatory: true,
        dynamic: true,
        isVisible: true,
        isMulti: true,
        lg1: 7
    },
    {
        label: 'Mines',
        value: 'mines',
        placeholder: 'Mines',
        inputType: 'dropdown',
        type: 'array',
        options: [],
        mandatory: false,
        dynamic: true,
        isVisible: true,
        isMulti: true,
        lg1: 7
    }
];
export const NEW_USER_REQUESTS_FORM_SCHEMA_CHECKBOX = [
    {
        label2: 'Privilege Details',
        value: 'privileges',
        inputType: 'checkbox',
        checked: false,
        type: 'checkbox',
        options: [
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'VIEW_CLIENT_AREAS', label3: 'View Client Areas' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'MAP_VIEW', label3: 'Map View' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'REPORTS', label3: 'Reports' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'DOWNLOADS', label3: 'Downloads' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'LAYERS', label3: 'Layers' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'SATELLITE', label3: 'Satellite' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'MEASURING_TOOL', label3: 'Measuring Tool' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'DEFAULT_POINTER', label3: 'Default Pointer' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'LEGENDS', label3: 'Legends' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'DRAW_TOOL', label3: 'Draw Tool' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'DRAWN_LAYERS', label3: 'Drawn Layers' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'IDENTIFIER', label3: 'Identifier' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'EXPORT', label3: 'Export' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'PRINT', label3: 'Print' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'ROTATE', label3: 'Rotate' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'COMPARISION', label3: 'Comparison' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'BUFFER_TOOL', label3: 'Buffer Tool' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: 'SITE_UPDATES', label3: 'Site Updates' },
            { lg1: 4, inputType: 'checkbox', type: 'checkbox', checked: false, value: '3D_SCENE', label3: '3D Scene' }
        ],
        mandatory: false,
        dynamic: true,
        isVisible: true,
        lg1: 6
    }
];
export const NEW_USER_REQUESTS_FORM_SCHEMA_REJECTION_COMMENT = [
    {
        label: 'Comments',
        value: 'comments',
        inputType: 'input',
        type: 'textarea',
        mandatory: true,
        isVisible: true,
        regex: regex.alphanumericSpecialChars,
        alphanumericspecial: true,
        lg1: 12,
        maxLen: 100
    }
];
export const NEW_REQUEST_VIEW_USER_FORM = [{}];

export const REJECT_COMMENT_FORM_SCHEMA = [
    {
        label: 'Comments',
        value: 'rejectComment',
        inputType: 'input',
        // regex: regex.alphaNumeric,
        // alphaNumeric: true,
        type: 'textarea',
        mandatory: true,
        isVisible: true,
        maxLen: 100,
        disabled: false
    }
];

export const PROFILE_SCHEMA = [
    {
        label: 'Upload Profile Image',
        value: 'profileImage',
        type: 'array',
        inputType: 'upload',
        mandatory: false,
        isVisible: true,
        isMultipleFiles: false,
        accept: { 'image/': ['.jpeg', '.png', '.jpg', '.svg'] },
        // fileTypeMsg: "Only JPEG, JPG, PNG files are accepted",
        fileSize: 52428800,
        noOfFiles: 2,
        size: 12,
        lg1: 12,
        xl: 12,
        height: 50
    },
    {
        label: 'First Name',
        value: 'fullName',
        inputType: 'centerItems',
        isVisible: true,
        lg1: 12,
        xl: 12
    },
    {
        label: 'Role',
        value: 'roles',
        inputType: 'centerItems',
        inputDateType: 'Array',
        isVisible: true,
        lg1: 12,
        xl: 12
    },
    // {
    //     label: 'Last Name',
    //     value: 'lastName',
    //     inputType: 'displayItems',
    //     isVisible: true,
    //     lg1: 12,
    //     xl: 12
    // },
    {
        label: 'Employee ID',
        value: 'empId',
        inputType: 'displayItems',
        isVisible: true,
        lg1: 12,
        xl: 12
    },
    {
        label: 'Email',
        value: 'email',
        inputType: 'displayItems',
        isVisible: true,
        lg1: 12,
        xl: 12
    },
    {
        label: 'Department',
        value: 'department',
        inputType: 'displayItems',
        isVisible: true,
        lg1: 12,
        xl: 12
    },
    {
        label: 'Phone Number',
        value: 'phoneNumber',
        inputType: 'displayItems',
        inputDateType: 'Array',
        isVisible: true,
        lg1: 12,
        xl: 12
    },

    {
        label: 'Address',
        value: 'address',
        inputType: 'displayItems',
        isVisible: true,
        lg1: 12,
        xl: 12
    }
];
export const PROFILE_SCHEMA_EDIT = [
    {
        label: 'Upload Profile Image',
        value: 'profileImage',
        type: 'array',
        inputType: 'upload',
        mandatory: false,
        isVisible: true,
        isMultipleFiles: false,
        accept: { 'image/': ['.jpeg', '.png', '.jpg', '.svg'] },
        // fileTypeMsg: "Only JPEG, JPG, PNG files are accepted",
        fileSize: 52428800,
        noOfFiles: 2,
        size: 12,
        lg1: 12,
        xl: 12,
        height: 50
    },
    {
        label: 'First Name',
        value: 'fullName',
        inputType: 'centerItems',
        isVisible: true,
        lg1: 12,
        xl: 12
    },
    {
        label: 'Role',
        value: 'roles',
        inputType: 'centerItems',
        inputDateType: 'Array',
        isVisible: true,
        lg1: 12,
        xl: 12
    },
    // {
    //     label: 'Last Name',
    //     value: 'lastName',
    //     inputType: 'displayItems',
    //     isVisible: true,
    //     lg1: 12,
    //     xl: 12
    // },

    {
        label: 'Employee ID',
        value: 'empId',
        inputType: 'displayItems',
        isVisible: true,
        lg1: 12,
        xl: 12
    },
    {
        label: 'Email',
        value: 'email',
        inputType: 'displayItems',
        isVisible: true,
        lg1: 12,
        xl: 12
    },
    {
        label: 'Department',
        value: 'department',
        inputType: 'displayItems',
        isVisible: true,
        lg1: 12,
        xl: 12
    },

    {
        label: 'Phone Number',
        value: 'phoneNumber',
        type: 'tel',
        inputType: 'inputgroup',
        mandatory: false,
        isVisible: true,
        inputgroupKey: 'phoneExtension',
        size: 6,

        notAllowZeros: true,
        phoneNumber: true,
        regex: regex.numbers,
        numbers: true,
        initialValue: {
            for: 'phoneExtension',
            label: 'India(+91)',
            value: '+91',
            validationPattern: '^[6789]\\d{9}$',
            maxLen: '10'
        },
        lg1: 12,
        xl: 12
    },
    {
        label: 'Address',
        value: 'address',
        inputType: 'input',
        type: 'textarea',
        mandatory: false,
        isVisible: true,
        regex: regex.alphanumericSpecialChars,
        alphanumericspecial: true,
        lg1: 12,
        xl: 12
    }
];

export const DYNAMIC_VOLUMETRIC_MEASUREMENTS_FORMSCHEMA = [
    {
        label: 'Select Type',
        value: 'selectMethod',
        placeholder: 'Select Type',
        inputType: 'dropdown',
        type: 'object',
        options: [
            {
                value: 'draw',
                label: 'Draw'
            },
            {
                value: 'drawnLayer',
                label: 'Drawn Layer'
            }
        ],
        mandatory: true,
        isVisible: true,
        isMulti: false,
        lg1: 12
    },
    {
        label: 'Select Tool',
        value: 'selecttool',
        inputType: 'polygonTool',
        mandatory: false,
        isVisible: true
    },
    {
        label: 'Select Layer',
        value: 'selectLayer',
        placeholder: 'Select Layer',
        inputType: 'dropdown',
        type: 'object',
        options: [
            {
                value: 'custom',
                label: 'Custom'
            }
        ],
        mandatory: false,
        isVisible: false,
        isMulti: false,
        lg1: 12
    },
    {
        label: 'Calculate On',
        value: 'calculateOn',
        placeholder: 'Calculate On',
        inputType: 'dropdown',
        type: 'object',
        options: [
            {
                value: 'DSM',
                label: 'DSM'
            }
        ],
        mandatory: false,
        isVisible: false,
        isMulti: false,
        lg1: 12
    }
];

export const DYNAMIC_VOLUMETRIC_DRAW_MEASUREMENTS_FORMSCHEMA = [
    {
        label: 'Feature Name',
        value: 'featureName',
        placeholder: 'Enter Feature Name',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        lg1: 12,
        maxLen: 40,
        minLen: 2
    },
    {
        label: 'Base Height(M)',
        value: 'baseHeight',
        placeholder: 'Enter Base Height',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        regex: regex.floatdecimal,
        lg1: 12,
        maxLen: 20
    },

    {
        label: 'Select Color',
        value: 'color',
        inputType: 'colorpicker',
        initialValue: '#000000',
        isVisible: true
    },
    {
        label: 'Calculate On',
        value: 'calculateOn',
        placeholder: 'Calculate On',
        inputType: 'dropdown',
        type: 'object',
        options: [
            {
                value: 'DSM',
                label: 'DSM'
            }
        ],
        mandatory: true,
        isVisible: true,
        isMulti: false,
        lg1: 12
    }
];

export const DYNAMIC_VOLUMETRIC_TWO_MEASUREMENTS_FORMSCHEMA = [
    {
        label: 'layer Name',
        value: 'layerName',
        placeholder: 'Layer Name',
        inputType: 'dropdown',
        type: 'object',
        options: [
            {
                value: 'customLayer',
                label: 'Custom Layer'
            }
        ],
        mandatory: true,
        isVisible: true,
        isMulti: false,
        lg1: 6
    },
    {
        label: 'Base Height(M)',
        value: 'baseHeight',
        placeholder: 'Enter Base Height',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        regex: regex.floatdecimal,
        lg1: 6,
        maxLen: 20
    },
    {
        label: 'Upload File',
        value: 'file',
        type: 'array',
        inputType: 'upload',
        mandatory: true,
        isVisible: true,
        isMultipleFiles: false,
        accept: { 'image/': ['.jpeg', '.png', '.jpg', '.svg'] },
        fileSize: 52428800,
        noOfFiles: 1,
        size: 12,
        lg1: 12,
        xl: 12,
        height: 50
    },
    {
        label: 'SRS (Spatial Reference System)',
        value: 'srs',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        regex: regex.alphaNumeric,
        alphaNumeric: true,
        lg1: 6,
        maxLen: 20,
        minLen: 3
    },
    {
        label: 'Calculate On',
        value: 'calculateOn',
        placeholder: 'Calculate On',
        inputType: 'dropdown',
        type: 'object',
        options: [
            {
                value: 'DSM',
                label: 'DSM'
            }
        ],
        mandatory: true,
        isVisible: true,
        isMulti: false,
        lg1: 6
    }
];

// FormSchema.tsx
export const DRAW_TOOL_FORM_SCHEMA = [
    {
        label: 'Layer Name',
        value: 'layerName',
        placeholder: 'Layer Name',
        inputType: 'dropdown',
        type: 'object',
        options: [
            {
                value: 'other',
                label: 'Other'
            }
        ],
        mandatory: true,
        // dynamic: true,
        isVisible: true,
        isMulti: false,
        lg1: 12
    },
    {
        label: 'Other',
        value: 'otherLayerName',
        placeholder: 'Layer Name',
        inputType: 'input',
        type: 'text',
        mandatory: false,
        // dynamic: true,
        isVisible: false,
        isMulti: false,
        lg1: 12,
        maxLen: 20
    },
    {
        label: 'Feature Name',
        value: 'featureName',
        placeholder: 'Enter Feature Name',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        lg1: 12,
        maxLen: 40,
        minLen: 2,
    },
    {
        label: 'Line Width',
        value: 'lineWidth',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        regex: regex.numbers,
        numbers: true,
        lg1: 12,
        maxLen: 3,
    },
    {
        label: 'Select Color',
        value: 'color',
        inputType: 'colorpicker',
        initialValue: '#000000',
        isVisible: true
    }
];

export const DRAW_TOOL_POINT_FORM_SCHEMA = [
    {
        label: 'Layer Name',
        value: 'layerName',
        placeholder: 'Layer Name',
        inputType: 'dropdown',
        type: 'object',
        options: [
            {
                value: 'other',
                label: 'Other'
            }
        ],
        mandatory: true,
        // dynamic: true,
        isVisible: true,
        isMulti: false,
        lg1: 12
    },
    {
        label: 'Other',
        value: 'otherLayerName',
        placeholder: 'Layer Name',
        inputType: 'input',
        type: 'text',
        mandatory: false,
        // dynamic: true,
        isVisible: false,
        isMulti: false,
        lg1: 12,
        maxLen: 20
    },
    {
        label: 'Feature Name',
        value: 'featureName',
        placeholder: 'Enter Feature Name',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        lg1: 12,
        maxLen: 40,
        minLen: 2,
    },
    {
        label: 'Point Border Width',
        value: 'lineWidth',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        regex: regex.numbers,
        numbers: true,
        lg1: 12,
        maxLen: 3,
    },
    {
        label: 'Border Color',
        value: 'borderColor',
        inputType: 'colorpicker',
        initialValue: '#000000',
        isVisible: true,
        lg1: 3
    },
    {
        label: 'Point Color',
        value: 'pointerColor',
        inputType: 'colorpicker',
        initialValue: '#000000',
        isVisible: true,
        lg1: 3
    },
    {
        label: 'Pointer Size',
        value: 'pointerSize',
        inputType: 'incDecButton',
        mandatory: false,
        isVisible: true,
        lg1: 3
    }
];

export const DRAW_TOOL_POLYGON_FORM_SCHEMA = [
    {
        label: 'Layer Name',
        value: 'layerName',
        placeholder: 'Layer Name',
        inputType: 'dropdown',
        type: 'object',
        options: [
            {
                value: 'other',
                label: 'Other'
            }
        ],
        mandatory: true,
        // dynamic: true,
        isVisible: true,
        isMulti: false,
        lg1: 12
    },
    {
        label: 'Other',
        value: 'otherLayerName',
        placeholder: 'Layer Name',
        inputType: 'input',
        type: 'text',
        mandatory: false,
        // dynamic: true,
        isVisible: false,
        isMulti: false,
        lg1: 12,
        maxLen: 20
    },
    {
        label: 'Feature Name',
        value: 'featureName',
        placeholder: 'Enter Feature Name',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        lg1: 12,
        maxLen: 40,
        minLen: 2,
    },
    {
        label: 'Layer Style',
        value: 'layerStyle',
        placeholder: 'Layer Style',
        inputType: 'dropdown',
        type: 'object',
        options: [
            {
                label: 'Filled',
                value: 'filled'
            },
            {
                label: 'Outlined',
                value: 'outlined'
            },
            {
                label: 'Filled + Outlined',
                value: 'filledPlusOutlined'
            }
        ],
        mandatory: true,
        // dynamic: true,
        isVisible: true,
        isMulti: false,
        lg1: 12
    },
    {
        label: 'Opacity',
        value: 'opacity',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        regex: regex.numbers,
        numbers: true,
        lg1: 12,
        maxLen: 3,
    },
    {
        label: 'Line Width',
        value: 'lineWidth',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        regex: regex.numbers,
        numbers: true,
        lg1: 12,
        maxLen: 3,
    },
    {
        label: 'Select Color',
        value: 'color',
        inputType: 'colorpicker',
        initialValue: '#000000',
        isVisible: true
    }
];

export const BUFFER_TOOL_SELECT_FORM_SCHEMA = [
    {
        label: 'Layer Name',
        value: 'layerName',
        placeholder: 'Layer Name',
        inputType: 'dropdown',
        type: 'object',
        options: [],
        mandatory: true,
        // dynamic: true,
        isVisible: true,
        isMulti: false,
        lg1: 12
    },

    {
        label: 'Feature Name',
        value: 'featureName',
        placeholder: 'Fearure Name',
        inputType: 'dropdown',
        type: 'object',
        options: [],
        mandatory: false,
        // dynamic: true,
        isVisible: true,
        isMulti: false,
        lg1: 12
    },
    {
        label: 'Offset',
        value: 'bufferDistance',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        regex: regex.numbers,
        numbers: true,
        lg1: 12,
        maxLen: 6,
        minLen: 1
    }
];

export const BUFFER_TOOL_MAP_SELECT_FORM_SCHEMA = [
    {
        label: 'Offset',
        value: 'bufferDistance',
        inputType: 'input',
        type: 'text',
        mandatory: true,
        isVisible: true,
        regex: regex.numbers,
        numbers: true,
        lg1: 12,
        maxLen: 20,
        minLen: 1
    }
];
